/**
 * Testi italiani dei codici regalo e degli inviti dei creator (ADR 0043): sezione delle
 * impostazioni e pagina dell'amministrazione.
 *
 * «Token» resta, come nella pagina del piano: è l'unità del regalo.
 */

/** Testi dei codici regalo. */
export const giftCodes = {
  /** Sezione dell'utente nelle impostazioni. */
  redeem: {
    /** Titolo della scheda. */
    title: 'Codice regalo',
    /** Che cosa fa. */
    intro: 'Un codice regalo aggiunge token da usare con la credenziale di institor quando finiscono quelli del piano.',
    /** Etichetta del campo. */
    field: 'Codice',
    /** Testo di aiuto del campo. */
    fieldHelp: 'Puoi scriverlo con o senza trattini.',
    /** Pulsante. */
    submit: 'Riscatta',
    /** Campo vuoto. */
    empty: 'Scrivi il codice da riscattare.',
    /** Riscatto riuscito. */
    done: 'Codice riscattato: {{tokens}} token aggiunti.',
    /** Avviso breve del riscatto riuscito. */
    doneToast: 'Codice riscattato.',
    /** Errore generico. */
    failed: 'Riscatto non riuscito. Riprova.',
    /** Errori per codice (ADR 0043 §2.2). */
    errors: {
      /** Codice inesistente. */
      gift_code_not_found: 'Codice non valido. Controlla di averlo scritto bene.',
      /** Disattivato. */
      gift_code_disabled: 'Codice disattivato. Chiedi un codice nuovo a chi te lo ha dato.',
      /** Scaduto. */
      gift_code_expired: 'Codice scaduto. Chiedi un codice nuovo a chi te lo ha dato.',
      /** Riscatti finiti. */
      gift_code_exhausted: 'Il codice è già stato usato da tutte le persone previste.',
      /** Già riscattato da questo utente. */
      gift_code_already_redeemed: 'Hai già riscattato questo codice.',
      /** Riservato a un altro utente. */
      gift_code_not_for_you: 'Questo codice è riservato a un altro account.',
      /** Codice di cui l'utente è creator. */
      gift_code_own_code: 'Non puoi riscattare un codice di cui sei creator.',
    },
    /** Titolo dell'elenco dei riscatti. */
    historyTitle: 'Codici riscattati',
    /** Totale dei token regalati. */
    total: 'Token regalati in totale: {{tokens}}',
    /** Token regalati ancora da usare. */
    remaining: 'Ancora da usare: {{tokens}}',
    /** Nessun riscatto. */
    none: 'Nessun codice riscattato.',
    /** Colonna del codice. */
    codeColumn: 'Codice',
    /** Colonna dei token. */
    tokensColumn: 'Token',
    /** Colonna della data. */
    dateColumn: 'Riscattato il',
    /** Lettura non riuscita. */
    loadFailed: 'Lettura dei codici riscattati non riuscita. Riprova.',
  },

  /** Inviti del creator. */
  referrals: {
    /** Titolo. */
    title: 'I tuoi inviti',
    /** Che cosa mostra. */
    intro: 'I codici che diffondi. Ricevi una percentuale di quanto pagano le persone che li riscattano.',
    /** Colonna del codice. */
    codeColumn: 'Codice',
    /** Colonna dei riscatti. */
    redemptionsColumn: 'Riscatti',
    /** Riscatti su massimo. */
    redemptionsOf: '{{used}} di {{max}}',
    /** Colonna degli invitati. */
    referredColumn: 'Persone invitate',
    /** Colonna della percentuale. */
    percentColumn: 'Percentuale',
    /** Colonna dello stato. */
    stateColumn: 'Stato',
    /** Stato attivo. */
    active: 'Attivo',
    /** Stato disattivato. */
    disabled: 'Disattivato',
    /** Stato scaduto. */
    expired: 'Scaduto',
    /** Titolo delle commissioni. */
    commissionsTitle: 'Commissioni maturate',
    /** Totale. */
    commissionsTotal: 'Totale: {{amount}}',
    /** Nessuna commissione. */
    commissionsNone: 'Nessuna commissione per ora.',
    /** Commissioni non leggibili. */
    commissionsUnavailable: 'Le commissioni non sono disponibili ora. Riprova più tardi.',
    /** Come si paga. */
    payoutNote: 'Le commissioni si pagano a mano: per riceverle scrivi a un amministratore.',
    /** Colonna della data. */
    dateColumn: 'Data',
    /** Colonna dell'importo pagato. */
    amountColumn: 'Pagato',
    /** Colonna della commissione. */
    commissionColumn: 'Commissione',
  },

  /** Pagina dell'amministrazione. */
  admin: {
    /** Scheda e voce di menu. */
    tab: 'Codici regalo',
    /** Titolo della pagina. */
    title: 'Codici regalo',
    /** Che cosa fa la pagina. */
    description: 'Codici che regalano token. I codici di gruppo si danno a un creator, che riceve una percentuale.',
    /** Lettura non riuscita. */
    loadFailed: 'Lettura dei codici non riuscita. Riprova.',
    /** Titolo del modulo. */
    newTitle: 'Nuovo codice',
    /** Etichetta del tipo. */
    kind: 'Tipo',
    /** Tipo singolo. */
    kindSingle: 'Singolo',
    /** Aiuto del tipo singolo. */
    kindSingleHelp: 'Una persona sola lo riscatta.',
    /** Tipo di gruppo. */
    kindGroup: 'Di gruppo',
    /** Aiuto del tipo di gruppo. */
    kindGroupHelp: 'Lo riscattano più persone, una volta ciascuna.',
    /** Etichetta dei token. */
    tokens: 'Token per riscatto',
    /** Aiuto dei token. */
    tokensHelp: 'Per esempio 25000000 per 25 milioni.',
    /** Etichetta del massimo. */
    maxRedemptions: 'Riscatti massimi',
    /** Aiuto del massimo. */
    maxRedemptionsHelp: 'Lascia vuoto per nessun limite.',
    /** Etichetta del destinatario. */
    restrictedTo: 'Riservato a',
    /** Aiuto del destinatario. */
    restrictedToHelp: 'Nome utente o email. Lascia vuoto per chiunque.',
    /** Etichetta del creator. */
    creator: 'Creator',
    /** Aiuto del creator. */
    creatorHelp: 'Nome utente o email di chi diffonde il codice. Lascia vuoto se nessuno.',
    /** Etichetta della percentuale. */
    percent: 'Percentuale del creator',
    /** Aiuto della percentuale. */
    percentHelp: 'Da 0 a 50. Si calcola su quanto pagano le persone invitate.',
    /** Etichetta della scadenza. */
    expiresAt: 'Scadenza',
    /** Aiuto della scadenza. */
    expiresAtHelp: 'Lascia vuoto se il codice non scade.',
    /** Etichetta della nota. */
    note: 'Nota',
    /** Pulsante di creazione. */
    create: 'Crea codice',
    /** Creazione riuscita. */
    created: 'Codice {{code}} creato.',
    /** Avviso breve della creazione. */
    createdToast: 'Codice creato.',
    /** Creazione non riuscita. */
    createFailed: 'Creazione non riuscita. Controlla i dati e riprova.',
    /** Token mancanti. */
    tokensRequired: 'Scrivi quanti token regala il codice.',
    /** Percentuale senza creator. */
    percentNeedsCreator: 'La percentuale serve solo con un creator.',
    /** Titolo dell'elenco. */
    listTitle: 'Codici',
    /** Elenco vuoto. */
    empty: 'Nessun codice creato.',
    /** Colonna del codice. */
    codeColumn: 'Codice',
    /** Colonna del tipo. */
    kindColumn: 'Tipo',
    /** Colonna dei token. */
    tokensColumn: 'Token',
    /** Colonna dei riscatti. */
    redemptionsColumn: 'Riscatti',
    /** Riscatti su massimo. */
    redemptionsOf: '{{used}} di {{max}}',
    /** Riscatti senza limite. */
    redemptionsUnlimited: '{{used}}, senza limite',
    /** Colonna del destinatario o creator. */
    whoColumn: 'Per chi',
    /** Riservato a. */
    whoRestricted: 'Solo {{name}}',
    /** Creator con percentuale. */
    whoCreator: 'Creator {{name}}, {{percent}}%',
    /** Invitati. */
    whoReferred: '{{count}} persone invitate',
    /** Per chiunque. */
    whoAnyone: 'Chiunque',
    /** Colonna della scadenza. */
    expiresColumn: 'Scade',
    /** Nessuna scadenza. */
    never: 'Mai',
    /** Colonna dello stato. */
    stateColumn: 'Stato',
    /** Attivo. */
    active: 'Attivo',
    /** Disattivato. */
    disabled: 'Disattivato',
    /** Colonna delle azioni. */
    actionsColumn: 'Azioni',
    /** Copia. */
    copy: 'Copia',
    /** Nome accessibile della copia. */
    copyAccessible: 'Copia il codice {{code}}',
    /** Copia riuscita. */
    copied: 'Codice copiato.',
    /** Copia non riuscita. */
    copyFailed: 'Copia non riuscita: trascrivi il codice a mano.',
    /** Disattiva. */
    disable: 'Disattiva',
    /** Nome accessibile della disattivazione. */
    disableAccessible: 'Disattiva il codice {{code}}',
    /** Riattiva. */
    enable: 'Riattiva',
    /** Nome accessibile della riattivazione. */
    enableAccessible: 'Riattiva il codice {{code}}',
    /** Conferma della disattivazione. */
    disableConfirmTitle: 'Disattivare il codice?',
    /** Testo della conferma. */
    disableConfirmText: 'Il codice {{code}} non si potrà più riscattare. I token già riscattati restano.',
    /** Annulla. */
    cancel: 'Annulla',
    /** Disattivazione riuscita. */
    disabledDone: 'Codice disattivato.',
    /** Riattivazione riuscita. */
    enabledDone: 'Codice riattivato.',
    /** Cambio non riuscito. */
    toggleFailed: 'Cambio non riuscito. Riprova.',
  },

  /** Piano regalato da un amministratore per alcuni mesi (ADR 0061). */
  planGrants: {
    /** Titolo della scheda. */
    title: 'Regala un piano',
    /** Che cosa fa il regalo. */
    intro: 'Il piano regalato vale per i mesi scelti, poi torna quello di prima. Un abbonamento pagato resta com’è.',
    /** Etichetta dell'utente. */
    user: 'Utente',
    /** Aiuto dell'utente. */
    userHelp: 'Cerca per nome, nome utente o email.',
    /** Segnaposto della ricerca. */
    userPlaceholder: 'Cerca un utente',
    /** Utente mancante. */
    userRequired: 'Scegli l’utente.',
    /** Etichetta del piano. */
    plan: 'Piano',
    /** Etichetta dei mesi. */
    months: 'Mesi',
    /** Aiuto dei mesi. */
    monthsHelp: 'Da 1 a 24. Se l’utente ha già un regalo dello stesso piano, i mesi si aggiungono alla fine.',
    /** Mesi mancanti. */
    monthsRequired: 'Scrivi quanti mesi regalare.',
    /** Etichetta della nota. */
    note: 'Nota',
    /** Pulsante. */
    submit: 'Regala',
    /** Titolo della conferma. */
    confirmTitle: 'Regalare il piano?',
    /** Testo della conferma. */
    confirmText: '{{user}} riceve il piano {{plan}} per {{months}} mesi.',
    /** Pulsante della conferma. */
    confirmOk: 'Regala',
    /** Regalo riuscito. */
    done: 'Piano regalato.',
    /** Regalo non riuscito. */
    failed: 'Regalo non riuscito. Controlla i dati e riprova.',
    /** Elenco degli utenti non letto. */
    usersFailed: 'Lettura degli utenti non riuscita. Ricarica la pagina.',
    /** Titolo dell'elenco. */
    listTitle: 'Piani regalati',
    /** Elenco vuoto. */
    empty: 'Nessun piano regalato in corso.',
    /** Lettura non riuscita. */
    loadFailed: 'Lettura dei piani regalati non riuscita. Riprova.',
    /** Colonna dell'utente. */
    userColumn: 'Utente',
    /** Colonna del piano. */
    planColumn: 'Piano',
    /** Colonna della fine. */
    untilColumn: 'Fino al',
    /** Regalo accodato: inizio. */
    startsOn: 'dal {{date}}',
    /** Colonna dell'amministratore. */
    byColumn: 'Da chi',
    /** Colonna della nota. */
    noteColumn: 'Nota',
    /** Colonna delle azioni. */
    actionsColumn: 'Azioni',
    /** Revoca. */
    revoke: 'Revoca',
    /** Nome accessibile della revoca. */
    revokeAccessible: 'Revoca il regalo a {{user}}',
    /** Titolo della conferma della revoca. */
    revokeConfirmTitle: 'Revocare il regalo?',
    /** Testo della conferma della revoca. */
    revokeConfirmText: '{{user}} perde subito il piano {{plan}} regalato e torna al piano di prima.',
    /** Revoca riuscita. */
    revoked: 'Regalo revocato.',
    /** Revoca non riuscita. */
    revokeFailed: 'Revoca non riuscita. Riprova.',
    /** Annulla. */
    cancel: 'Annulla',
  },
};

/** Forma dei testi dei codici regalo. */
export type GiftCodes = typeof giftCodes;
